import React from "react";
import { GetImages } from "../utils/GetImages";
import CurrencyTooltip from "../components/currencytooltip/CurrencyTooltip";

const CardContainer = ({
  heading,
  sub_data,
  image,
  onClick = () => {},
  currency = false,
  raw = "",
  isLoading = false,
}) => {
  return (
    <>
      <div className="dashboard-data-card">
        <span className="dashboard-data-card-img BackgroundlightBlue ">
          <img src={image} className="Icon20" />
        </span>
        <div className="dashboard-data-card-middle w-100">
          {isLoading ? (
            <div className="d-flex flex-column justify-content-center w-100 pe-3">
              <span className="skeleton-loader skeleton-title"></span>
              <span className="skeleton-loader skeleton-text"></span>
            </div>
          ) : currency ? (
            <div
              style={{
                justifyContent: "start",
                alignItems: "start",
              }}
            >
              {heading === undefined ? (
                <span className="heading black">NA</span>
              ) : (
                <CurrencyTooltip content={raw} formatted={heading}>
                  <span className="heading black">{heading}</span>
                </CurrencyTooltip>
              )}
            </div>
          ) : (
            <p className="heading black">{heading === undefined ? "NA" : heading}</p>
          )}
          <p className="normal_text grey_subtext1">{sub_data}</p>
        </div>
        <img src={GetImages.LinkIcon} onClick={onClick} className="clickable" />
      </div>
    </>
  );
};

export default CardContainer;
